/**
 *
 */
var Extensions = (function () {
    function Extensions() {
    }
    return Extensions;
}());
export { Extensions };
Extensions.SIMD = Boolean(typeof (SIMD) !== "undefined");



// WEBPACK FOOTER //
// ../dist/lib/utils/Extensions.js